import gql from 'graphql-tag';

import ImageFragment from './fragments/image';

export default gql`
  query GetDownloadSectionFromAllAppData {
    allAppData(limit: 1) {
      _id
      appDownloadSection {
        primaryImage {
          locale: _LANG_ {
            ...ImageFragment
          }
        }
        headerSuperText {
          locale: _LANG_
        }
        header {
          locale: _LANG_
        }
        copy {
          locale: _LANG_
        }
        textDecorationLeft {
          ...ImageFragment
        }
        textDecorationRight {
          ...ImageFragment
        }
        submitButtonText {
          locale: _LANG_
        }
        iOSDownloadLink
        iOSDownloadImage {
          locale: _LANG_ {
            ...ImageFragment
          }
        }
        androidDownloadLink
        androidDownloadImage {
          locale: _LANG_ {
            ...ImageFragment
          }
        }
      }
    }
  }
  ${ImageFragment}
`;
